export const DEFAULT_STEP_VALUE = 1;
